import React from 'react'
import { translation } from 'assets/translations/translations'
import english from 'assets/translations/en.json'
import macedonian from 'assets/translations/mk.json'
import './Product.css'

type Props = {
  img: string
  text: keyof typeof english | keyof typeof macedonian
  header: keyof typeof english | keyof typeof macedonian
  before: boolean
  language: string
}

const Product = ({ img, text, header, before, language }: Props) => (
  <section className={`product-main ${before ? 'product-normal' : 'product-reverse'}`}>
    {before && (
      <div className='product-text'>
        <span className='product-kicker'>{translation(language, 'product-small-title')}</span>
        <h3 className='product-header'>{translation(language, header)}</h3>
        <div className='product-about'>{translation(language, text)}</div>
      </div>
    )}

    <div className='product-img-container'>
      <img src={img} alt={String(header)} className='product-img' />
    </div>

    {!before && (
      <div className='product-text'>
        <span className='product-kicker'>{translation(language, 'product-small-title')}</span>
        <h3 className='product-header'>{translation(language, header)}</h3>
        <div className='product-about'>{translation(language, text)}</div>
      </div>
    )}
  </section>
)

export default Product